import * as o from "fp-ts/lib/Option";
import { isNumber as m } from "fp-ts/lib/number";
import { isString as n } from "fp-ts/lib/string";
import { match as l } from "ts-pattern";
import { i } from "./isObject-BWFWCQho.mjs";
import { i as t } from "./isArray-QlWcxgml.mjs";
function N(r) {
  return l(r).when(Number.isNaN, () => o.none).when(m, o.fromNullable).when(n, (e) => e === "" ? o.none : o.fromNullable(e)).when(
    i,
    (e) => Object.keys(e || {}).length === 0 ? o.none : o.fromNullable(e)
  ).when(
    t,
    (e) => e.length === 0 ? o.none : o.fromNullable(e)
  ).otherwise((e) => o.fromNullable(e));
}
export {
  N as f
};
//# sourceMappingURL=fromEmpty-CUaiIlpZ.mjs.map
